import { render, staticRenderFns } from "./__CustomPrice.vue?vue&type=template&id=7581ce6a&scoped=true"
import script from "./__CustomPrice.vue?vue&type=script&lang=js"
export * from "./__CustomPrice.vue?vue&type=script&lang=js"
import style0 from "./__CustomPrice.vue?vue&type=style&index=0&id=7581ce6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581ce6a",
  null
  
)

export default component.exports